import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { BaasicDropdown, Loader } from 'core/components';

const CloseOutExitTemplate = ({
	t,
	closeOutExitViewStore: { loading, form, warehouseDropdownStore },
}) => {
	if (loading) return <Loader />;
	return (
		<section>
			<form className="ReactModal__form" onSubmit={form.onSubmit}>
				<div className="ReactModal__header">
					<h3 className="spc--bottom--sml">{t('CLOSEOUTEXITVIEW.TITLE')}</h3>
				</div>
				<div className="ReactModal__body">
					<BaasicDropdown dropdownStore={warehouseDropdownStore} className="spc--bottom--sml flex--grow--1" />
				</div>
				<div className="ReactModal__footer">
					<button
						className="btn btn--med btn--primary spc--bottom--sml"
						type="submit"
						disabled={!form.$('warehouseId').value}
					>
						{t('CONFIRMTHIS')}
					</button>
				</div>
			</form>
		</section>
	);
};

export default defaultTemplate(CloseOutExitTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/CloseOutExitTemplate.jsx